import { LOCATION_CHANGE } from 'typed/utils/redux';

export default function (store) {
    return function (next) {
        return function (action) {
            if (action.type === LOCATION_CHANGE && window.Intercom) {
                try {
                    //setTimeout(() => window.Intercom && window.Intercom('update')); // wait until action is complete
                    // disable for now
                }
                catch (e) {
                    // if Intercom's broken, we should still continue running our application
                }
            }
            return next(action);
        }
    }
};